// extracted by mini-css-extract-plugin
export default {"container":"Nk-z","freeShip":"Ok-z","privacy":"Pk-z"};